import { render, staticRenderFns } from "./CheckOrder.vue?vue&type=template&id=0d15c3fd&scoped=true"
import script from "./CheckOrder.vue?vue&type=script&lang=js"
export * from "./CheckOrder.vue?vue&type=script&lang=js"
import style0 from "./CheckOrder.vue?vue&type=style&index=0&id=0d15c3fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15c3fd",
  null
  
)

export default component.exports